import React from 'react'

const SectionHeader = ({mainText1, mainText2}) => {
  return (
    <h2 className='volto-section-header'>{mainText1} <span>{mainText2}</span></h2>
  )
}

export default SectionHeader
